import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Adv1Page } from './pages/Adv1Page';
import { Adv2Page } from './pages/Adv2Page';
import { Adv3Page } from './pages/Adv3Page';
import { GlpAdv1Page } from './pages/GlpAdv1Page';
import { GlpAdv2Page } from './pages/GlpAdv2Page';
import { GlpAdv3Page } from './pages/GlpAdv3Page';
import { GlpAdv4Page } from './pages/GlpAdv4Page';
import { GlpAdv5Page } from './pages/GlpAdv5Page';
import { GlpAdv6Page } from './pages/GlpAdv6Page';
import { Glp6TipsPage } from './pages/Glp6TipsPage';
import { Glp6TipsBPage } from './pages/Glp6TipsBPage';
import { Glp6TipsCPage } from './pages/Glp6TipsCPage';
import { Glp6TipsDPage } from './pages/Glp6TipsDPage';
import { Glp6TipsEPage } from './pages/Glp6TipsEPage';
import { Glp6TipsFPage } from './pages/Glp6TipsFPage';
import { Glp6TipsGPage } from './pages/Glp6TipsGPage';
import { GlpPlateau1Page } from './pages/GlpPlateau1Page';
import { GlpPlateau2Page } from './pages/GlpPlateau2Page';
import { GlpPlateau3Page } from './pages/GlpPlateau3Page';
import { GlpPlateau4Page } from './pages/GlpPlateau4Page';
import { Rlt1Page } from './pages/Rlt1Page';
import { Rlt2Page } from './pages/Rlt2Page';
import { GlpInvestigationBPage } from './pages/GlpInvestigationBPage';
import { GlpInvestigationCPage } from './pages/GlpInvestigationCPage';
import { GlpInvestigationDPage } from './pages/GlpInvestigationDPage';
import { GlpInvestigationEPage } from './pages/GlpInvestigationEPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-20">
      <Routes data-id="element-21">
        <Route path="/" element={<App data-id="element-23" />} data-id="element-22" />
        <Route path="/adv-1" element={<Adv1Page data-id="element-25" />} data-id="element-24" />
        <Route path="/glp1-investigation" element={<Adv2Page data-id="element-27" />} data-id="element-26" />
        <Route path="/glp1-investigation-b" element={<GlpInvestigationBPage data-id="element-29" />} data-id="element-28" />
        <Route path="/glp1-investigation-c" element={<GlpInvestigationCPage data-id="element-31" />} data-id="element-30" />
        <Route path="/glp1-investigation-d" element={<GlpInvestigationDPage data-id="element-33" />} data-id="element-32" />
        <Route path="/glp1-investigation-e" element={<GlpInvestigationEPage data-id="element-35" />} data-id="element-34" />
        <Route path="/glp-adv-1" element={<GlpAdv1Page data-id="element-37" />} data-id="element-36" />
        <Route path="/glp-adv-2" element={<GlpAdv2Page data-id="element-39" />} data-id="element-38" />
        <Route path="/glp-adv-3" element={<GlpAdv3Page data-id="element-41" />} data-id="element-40" />
        <Route path="/glp-adv-4" element={<GlpAdv4Page data-id="element-43" />} data-id="element-42" />
        <Route path="/glp-adv-5" element={<GlpAdv5Page data-id="element-45" />} data-id="element-44" />
        <Route path="/glp-adv-6" element={<GlpAdv6Page data-id="element-47" />} data-id="element-46" />
        <Route path="/glp-6-tips" element={<Glp6TipsPage data-id="element-49" />} data-id="element-48" />
        <Route path="/glp-6-tips-b" element={<Glp6TipsBPage data-id="element-51" />} data-id="element-50" />
        <Route path="/glp-6-tips-c" element={<Glp6TipsCPage data-id="element-53" />} data-id="element-52" />
        <Route path="/glp-6-tips-d" element={<Glp6TipsDPage data-id="element-55" />} data-id="element-54" />
        <Route path="/glp-6-tips-e" element={<Glp6TipsEPage data-id="element-57" />} data-id="element-56" />
        <Route path="/glp-6-tips-f" element={<Glp6TipsFPage data-id="element-59" />} data-id="element-58" />
        <Route path="/glp-6-tips-g" element={<Glp6TipsGPage data-id="element-61" />} data-id="element-60" />
        <Route path="/glp-plateau-1" element={<GlpPlateau1Page data-id="element-63" />} data-id="element-62" />
        <Route path="/glp-plateau-2" element={<GlpPlateau2Page data-id="element-65" />} data-id="element-64" />
        <Route path="/glp-plateau-3" element={<GlpPlateau3Page data-id="element-67" />} data-id="element-66" />
        <Route path="/glp-plateau-4" element={<GlpPlateau4Page data-id="element-69" />} data-id="element-68" />
        <Route path="/rlt-1" element={<Rlt1Page data-id="element-71" />} data-id="element-70" />
        <Route path="/rlt-2" element={<Rlt2Page data-id="element-73" />} data-id="element-72" />
        <Route path="/adv-3" element={<Adv3Page data-id="element-75" />} data-id="element-74" />
      </Routes>
    </BrowserRouter>;
}